import { Link } from "react-router-dom";
import LegalShell, { Section, MailLink } from "@/components/LegalShell";

const li = "list-disc pl-5 space-y-1";

export default function Terms() {
  return (
    <LegalShell kicker="Legal" title="Terms of Use" updated="2 November 2026" testId="terms-page" path="/terms" docTitle="Terms of Use · Astra">
      <p>
        These terms apply to Astra at astralogico.com and the Astra iPhone app ("Astra", "we", "us"). Astra is operated by
        OddlyTrue Publishing, London, England. By using Astra you agree to these terms. If you don't agree, please don't use Astra.
      </p>

      <Section title="1. What Astra is">
        <p>Astra offers horoscopes, birth chart readings, planet pages, compatibility guides and Astra Interactive, based on
          astronomical calculations and written with the help of AI. Astra is for entertainment and self-reflection only. It is not
          medical, psychological, financial, legal or other professional advice, and you should not make important decisions based
          solely on a horoscope or reading.</p>
      </Section>

      <Section title="2. Your account">
        <ul className={li}>
          <li>You must be at least 16 years old to create an account.</li>
          <li>Please give accurate details, keep your password private and tell us if you think someone else has used your account.</li>
          <li>You can delete your account at any time from your Sanctuary (profile). See our <Link to="/privacy" className="gold-text">Privacy Policy</Link> for how we handle your data.</li>
        </ul>
      </Section>

      <Section title="3. Premium, readings and payments">
        <ul className={li}>
          <li>Astra Premium is a subscription that renews automatically each month or year until you cancel. Prices are shown before you pay and include any taxes we're required to charge.</li>
          <li>On the website, payments are processed by Stripe. In the iPhone app, purchases are handled by Apple and Apple's terms apply.</li>
          <li>You can cancel at any time. Premium stays active until the end of the period you've paid for.</li>
          <li>One-off readings and gifted readings are delivered digitally. Because they're written for you as soon as you buy, they can't be returned once delivered, but if something goes wrong please contact us and we'll put it right.</li>
          <li>Nothing in these terms affects your statutory rights as a consumer under the laws of England and Wales.</li>
          <li>Free offers (for example a free reading with Premium) last for the dates shown and may change or end.</li>
        </ul>
      </Section>

      <Section title="4. Acceptable use">
        <ul className={li}>
          <li>Don't misuse Astra: no attempts to break, overload or reverse-engineer the service, scrape it at scale, or access other people's accounts.</li>
          <li>Don't use Astra Interactive to create content that is unlawful, abusive or harmful.</li>
          <li>Gifts and invites must only be sent to people who would welcome them.</li>
        </ul>
      </Section>

      <Section title="5. Content and ownership">
        <p>Astra's text, design, illustrations and software belong to OddlyTrue Publishing or our licensors. Readings written for
          you are yours to keep and share for personal, non-commercial use. Please credit astralogico.com when you share them.</p>
      </Section>

      <Section title="6. Availability and changes">
        <p>We work to keep Astra available and accurate, but we can't promise it will always be uninterrupted or error-free. We
          may update features, and we may update these terms; if a change is significant we'll let you know in the app or by email.</p>
      </Section>

      <Section title="7. Liability">
        <p>We are not liable for decisions you make based on Astra's content, or for losses that weren't reasonably foreseeable.
          Our total liability to you for any claim is limited to the amount you paid us in the 12 months before the claim. Nothing
          here limits liability for death or personal injury caused by negligence, fraud, or anything else that can't be limited by law.</p>
      </Section>

      <Section title="8. Ending your use">
        <p>You can stop using Astra and delete your account at any time. We may suspend or close accounts that break these terms.</p>
      </Section>

      <Section title="9. Law">
        <p>These terms are governed by the laws of England and Wales, and the courts of England and Wales have jurisdiction,
          except where your local consumer law gives you the right to bring a claim where you live.</p>
      </Section>

      <Section title="10. Contact">
        <p>OddlyTrue Publishing, London, England · <MailLink /></p>
      </Section>
    </LegalShell>
  );
}
